export const getRoadSegmentsUrl = "/api/v3/defs/road";

// to fetch/get closest road-segment to latLng string
export const getClosestRoadSegmentsUrl = "/api/v3/defs/road_segment/viewable";

// get road segment by segmentId
export const getRoadSegmentByIdUrl = "/api/v3/defs/road_segment/:id";
